import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  buttonSave: {
    background: '#43a047',
    // border: '1px solid #43a047',
    color: '#fff',
    minWidth: 90,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'initial',
    transition: '0.4s',
    '&:hover': {
      background: '#0f7047',
    },
  },
}));

const SaveButton = ({ children, onClick, disabled, endIcon, type, id, className, styles, variant = 'contained' }) => {
  const classes = useStyles();
  return (
    <Button
      className={`${styles || classes.buttonSave} ${className}`}
      onClick={onClick}
      disabled={disabled}
      endIcon={endIcon}
      id={id}
      name="submit"
      variant={variant}
      type={type}
    >
      <Typography>{children}</Typography>
    </Button>
  );
};
SaveButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  id: PropTypes.string,
};

SaveButton.defaultProps = {
  id: 'submit',
  type: 'submit',
};

export default SaveButton;
